import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import usePasswordCriteria from '@/hooks/usePasswordCriteria';

import { CriteriaListItem } from './CriteriaListItem';

export type SetPasswordCriteriaListProps = {
    className?: string;
    password: string;
    showErrorFeedback: boolean;
    testid?: string;
};

export const SetPasswordCriteriaList = ({
    className,
    password,
    showErrorFeedback,
    testid = 'passwordCriteriaList',
}: SetPasswordCriteriaListProps) => {
    const { lengthCriteria, lowerAndUpperCaseCriteria, numberOrSpecialCharCriteria } = usePasswordCriteria(password);

    return (
        <ul
            className={cn('mt-0 mb-md ps-sm text-left', className)}
            data-testid={testid}
        >
            <CriteriaListItem
                showErrorFeedback={showErrorFeedback}
                valid={lengthCriteria}
            >
                <FormattedMessage id="caterwaul.passwords.passwordCriteriaList.length" />
            </CriteriaListItem>
            <CriteriaListItem
                showErrorFeedback={showErrorFeedback}
                valid={lowerAndUpperCaseCriteria}
            >
                <FormattedMessage id="caterwaul.passwords.passwordCriteriaList.lowerAndUpperCase" />
            </CriteriaListItem>
            <CriteriaListItem
                showErrorFeedback={showErrorFeedback}
                valid={numberOrSpecialCharCriteria}
            >
                <FormattedMessage id="caterwaul.passwords.passwordCriteriaList.numberOrSpecialChar" />
            </CriteriaListItem>
        </ul>
    );
};
